import { render, screen } from '@testing-library/react';

import type { IconProps } from 'components/Icon';

import { MetaDataBar } from './MetaDataBar';

jest.mock('components/Icon', () => ({
  Icon: ({ name }: { name: IconProps['name'] }) => <span data-testid="icon">{name}</span>,
}));

const mockItemData = [
  { iconName: 'AcademicCap' as IconProps['name'], itemLabel: 'Jedi Academy' },
  { iconName: 'User' as IconProps['name'], itemLabel: 'Luuk Hemelwandelaar' },
];

describe('MetaDataBar', () => {
  it('renders correctly with content items', () => {
    render(<MetaDataBar itemData={mockItemData} />);

    expect(screen.getByText('AcademicCap')).toBeInTheDocument();
    expect(screen.getByText('Jedi Academy')).toBeInTheDocument();
    expect(screen.getByText('User')).toBeInTheDocument();
    expect(screen.getByText('Luuk Hemelwandelaar')).toBeInTheDocument();

    expect(screen.getAllByTestId('icon')).toHaveLength(mockItemData.length);
  });

  it('renders nothing when content is empty', () => {
    render(<MetaDataBar itemData={[]} />);
    expect(screen.queryByTestId('icon')).not.toBeInTheDocument();
    expect(screen.queryByText(/.+/)).not.toBeInTheDocument();
  });
});
